define(
  [
    'app',
    './views/modalCropping',
    './models/Avatar',
    './templates/avatar.html',
    './templates/avatarWrapper.html',
    'utils/userAvatar',
    'nouislider',
    'cropper'
  ],
  function (
    app,
    ModalCroppingView,
    AvatarModel,
    tmplAvatar,
    tmplAvatarWrapper,
    userAvatar
  ) {
    return app.Marionette.ItemView.extend({
      options: {
        width: 150,
        height: 150,
        cropPreviewHeight: 150,
        cropPreviewWidth: 150,
        allowed_files_size: '5 MB',
        margin: 14,
        type: 'circle',
        customWrapper: tmplAvatarWrapper,
        setTo: false,
        labels: {
          edit_button: 'Edit',
          remove_link: 'Remove avatar',
          upload_button: 'Apply',
          cancel_link: 'Cancel',
          timeout_error: 'Sorry connection timed out. Please try again or use a smaller image.',
          uploader: {}
        },
        disable: false
      },

      ui: {
        error_box: '.box--alert',
        preview: '.js-preview',
        avatar: '.avatar-uploader > .avatar',
        edit_btn: '.avatar-uploader__edit > button',
        delete: '.avatar-uploader__edit > .avatar-delete',
        field: '>input[type="hidden"]',
        upload: '.upload',
        crop_modal: '#modal_crop',
        crop_image: '.modal-crop__top img',
        previews: '.previews img',
        save_crop: '.js-save-crop',
        cancel_crop: '.js-cancel-crop',
        zoom: 'input[type="range"]'
      },

      triggers: {
        'click @ui.cancel_crop': 'cropping:cancel',
        'click @ui.save_crop': 'cropping:save',
        'click @ui.avatar': {
          event: 'avatar:change',
          preventDefault: true, // this param is optional and will default to true
          stopPropagation: false
        },
        'click @ui.edit_btn': {
          event: 'avatar:change',
          preventDefault: true, // this param is optional and will default to true
          stopPropagation: false
        },
        'click @ui.delete': 'avatar:delete'
      },

      // Dependencies with other components
      components: {
        uploader: function () {
          var self = this
          return {
            name: 'uploader',
            el: self.$el,
            extend: {
              triggers: self.getOption('disable') ? {} : {
                'click .avatar-uploader > .avatar': 'upload:choose',
                'click .avatar-uploader__edit > button': 'upload:choose'
              }
            },
            data: {
              labels: self.getOption('labels').uploader,
              allowed_files_size: self.getOption('allowed_files_size'),
              width: self.getOption('width'),
              height: self.getOption('height')
            }
          }
        },

        modal: function () {
          var self = this
          return {
            name: 'modal',
            el: '@ui.crop_modal',
            data: {
              modal_id: 'modal_crop',
              mainClass: 'modal--crop',
              showCloseBtn: false,
              closeOnBgClick: false,
              enableEscapeKey: false,
              callbacks: {
                open: function () {
                  self.triggerMethod('modal:cropping:open', this.content)
                }
              }
            }
          }
        }
      },

      uploader: false,
      onComponentUploaderLoaded: function (instance) {
        var self = this
        var width = self.getOption('width')
        var height = self.getOption('height')

        self.uploader = instance

        instance.on('image:upload:start', function () {
          self.ui.error_box.addClass('is-hidden')
          self.ui.edit_btn.addClass('is-loading')
          self.ui.delete.addClass('is-hidden')
          app.events.commands.execute('notification:clean')
        })

        instance.on('image:upload:end', function (json) {
          json.cropped = false
          var img = new window.Image()

          img.onload = function () {
            // If lower then the image would be consider cropped
            if (width > this.width || height > this.height) {
              json.cropped = true
            }

            self.ui.delete.show()
            self.model.set(json)
          }

          img.src = json.source
        })

        instance.on('upload:error', function (errors) {
          self.ui.delete.removeClass('is-hidden')
          self.ui.edit_btn.removeClass('is-loading')
          self.triggerMethod('show:errors', errors)
        })
      },

      onShowErrors: function (errors) {
        if (errors.length > 1) {
          var _errors = app._.map(errors, function (error) {
            return { type: 'error', msg: error }
          })
          app.events.commands.execute('notification:show', _errors)
        } else if (errors[0] === '') {
          app.events.commands.execute('notification:show', [
            { type: 'error', msg: this.getOption('labels').timeout_error }
          ])
        } else {
          app.events.commands.execute('notification:show', [
            { type: 'error', msg: errors[0] }
          ])
        }
      },

      onModalCroppingOpen: function (item) {
        var self = this
        var opts = app._.extend({}, this.options)

        opts.el = item

        var modal = new ModalCroppingView(opts).render()

        this.listenTo(modal, 'modal:cropping:save', function (data) {
          self.triggerMethod('save:crop', data)
        })

        this.listenTo(modal, 'modal:cropping:cancel', function () {
          self.triggerMethod('cancel:crop')
        })
      },

      setValueOnInput: function () {
        app.$(this.original_input).val(this.model.getFullAvatar())
      },

      // To be cleanup
      onAvatarDelete: function () {
        var self = this
        app.$.ajax({
          url: '/member/avatarDelete',
          type: 'POST',
          success: function (msg) {
            self.model.set({
              source: msg.success,
              cropped: true
            })
          }
        })
      },

      // To be cleanup
      onCancelCrop: function () {
        app.events.commands.execute('modal:modal_crop:hide')
        this.model.set({
          source: this.model._previousAttributes.source,
          cropped: true
        })
      },

      onSaveCrop: function (data) {
        var self = this
        var sendData = {}

        sendData.x = data.cropX
        sendData.y = data.cropY
        sendData.width = data.cropW
        sendData.height = data.cropH
        sendData.url = this.model.getFullAvatar()

        app.$.ajax({
          url: '/member/avatar',
          data: sendData,
          method: 'post',
          success: function (msg) {
            self.model.set({
              source: msg.thumb_path,
              cropped: true
            })
            app.events.commands.execute('modal:modal_crop:hide')
          },
          error: function () {}
        })
      },

      onAvatarChange: function () {
        if (this.uploader) {
          this.uploader.trigger('file:choose')
        }
      },

      onRender: function () {
        if (this.model.changed.source && !this.model.get('cropped')) {
          app.events.commands.execute(
            'modal:modal_crop:show',
            this.ui.crop_modal,
            {}
          )
        }
      },

      setModel: function () {
        // Create the model avatar
        this.original_input = app.$(this.getOption('setTo'))
        this.model = new AvatarModel({
          source: this.original_input.val()
        })
          .on('change', this.render.bind(this))
          .on('change:source', this.setValueOnInput.bind(this))
      },

      template: tmplAvatar,

      templateHelpers: function () {
        var self = this
        var isDefaultAvatar = userAvatar.isDefaultAvatar(self.model.get('source'))
        return {
          width: self.getOption('cropPreviewWidth') || self.getOption('width'),
          height: self.getOption('cropPreviewHeight') || self.getOption('height'),
          margin: self.getOption('margin'),
          avatar: self.model.getFullAvatar(),
          avatar_full: self.model.getFullAvatar(),
          isDefaultAvatar: isDefaultAvatar,
          customWrapper: function (avatar) {
            var wrapper = self.getOption('customWrapper')
            if (!wrapper) return false
            return wrapper({
              avatar: avatar,
              generatedAvatarClass: userAvatar.getAvatarClass(self.getOption('userid')),
              avatarInital: userAvatar.getAvatarInital(self.getOption('username')),
              isDefaultAvatar: isDefaultAvatar
            })
          },
          labels: self.getOption('labels')
        }
      },

      initialize: function () {
        this.setModel()
      }
    })
  }
)
